<template>
  <el-dialog :visible.sync="visible" title="班级和学生升级" :close-on-click-modal="false" :close-on-press-escape="false" width="30%">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale==='en-US'?'120px':'80px'">
      <template>
        <el-checkbox-group v-model="checkedSchool" @change="handleCheckedCitiesChange">
          <el-checkbox style="display:block;" v-for="school in schoolList" :label="school.id" :key="school.id">{{school.schoolName}}</el-checkbox>
        </el-checkbox-group>
      </template>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { Loading } from 'element-ui'
export default {
  name: 'student-and-class-file',
  data () {
    return {
      visible: false,
      schoolVisible: false,
      schoolList: [],
      checkedSchool: [],
      dataForm: {
        passWord: '',
        schoolId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        this.getSchoolList()
      })
    },
    handleCheckedCitiesChange () {
      console.log(this.checkedSchool)
    },
    getSchoolList () {
      this.$http.get('school/school/getSchoolList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.schoolList = res.data
      })
    },
    dataFormSubmitHandle: debounce(function () {
      const loadingInstance = Loading.service(this.loadOptions)
      this.$confirm(this.$t('prompt.info', { handle: '是否进行学生升级' }), '是否进行学生升级', {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        const params = {
          checkedSchool: this.checkedSchool
        }
        console.log(this.checkedSchool)
        console.log(params.checkedSchool)
        this.$http.post('/schoolyear/studentfiled/studentAndClassFile', params).then(({ data: res }) => {
          loadingInstance.close()
          if (res.code !== 0) {
            if (res.code === 10050) {
              this.schoolVisible = true
              this.getSchoolList()
            }
            // this.dataListLoading = false
            return this.$message.error(res.msg)
          }
          // this.dataListLoading = false
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
            }
          })
        }).catch((err) => {
          console.log(err)
        })
      }, 1000, { leading: true, trailing: false })
    })
  }
}
</script>

<style scoped>

</style>
